import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from './Modal';
import axios from 'axios';
import PlateformService from './PlateformService';
import { header } from './header.encry';

import Select from "react-select";
import { icon } from 'leaflet';
import { fetchInventoryAskByStore, isAskActive } from '../services/inventoryAskService';
import * as Collapsible from '@radix-ui/react-collapsible';
import { ChevronRight } from 'lucide-react';
import { Sheet, SheetContent, SheetTitle, SheetDescription } from './ui/sheet';
import BrandLogo from './layout/BrandLogo';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import CalculateIcon from '@mui/icons-material/Calculate';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CategoryIcon from '@mui/icons-material/Category';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TuneIcon from '@mui/icons-material/Tune';
import PublicIcon from '@mui/icons-material/Public';
import MailIcon from '@mui/icons-material/Mail';


function Sidebar(props) {
    const location = useLocation();
    const API_URL = process.env?.REACT_APP_PEGASUS_API_URL;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [notallowed, setNotAllowed] = useState(process.env.REACT_APP_NOT_ALLOWED);
    const [stores, setStores] = useState([]);
    const [role, setRole] = useState([]);
    const [selectedStore, setSelectedStore] = useState([]);
    const [hasInventoryAsk, setHasInventoryAsk] = useState(false);
    const [hasGlovoPlateform, setHasGlovoPlateform] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
    useEffect(() => {
        const timer = window.setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
        return () => window.clearTimeout(timer);
    }, [sidebarOpen]);
    const defaultStoreId = sessionStorage.getItem('default_store_id') || '';
    const isAllowed = (entry = "") => {

        return (role && role.length > 0 && role.find(f => f == "admin")) ?? false;
    }
    useEffect(() => {
        const resolveRoles = () => {
            try {
                const storedRoles = sessionStorage.getItem('roles');
                const parsedRoles = storedRoles ? JSON.parse(storedRoles) : [];
                setRole(parsedRoles);
                console.log(parsedRoles);
            } catch (error) {
                console.warn('Unable to parse roles from session storage', error);
                setRole([]);
            }
        };

        // initialize roles on mount
        resolveRoles();
    }, []);

        
    useEffect(() => {
        const checkInventoryAsk = async () => {
            if (!defaultStoreId) {
                setHasInventoryAsk(false);
                return;
            }

            try {
                const ask = await fetchInventoryAskByStore(defaultStoreId);
                setHasInventoryAsk(isAskActive(ask));
            } catch (error) {
                setHasInventoryAsk(false);
            }
        };

        if (role?.includes('carrefour') || role?.includes('operator') || role?.includes('driver')) {
            checkInventoryAsk();
        }
    }, [defaultStoreId, role]);

    useEffect(() => {
        const detectGlovoPlateforms = async () => {
            try {
                const data = await PlateformService.fetchPlateforms();
                const list = data?.response || data || [];
                const hasGlovo = Array.isArray(list)
                    ? list.some((plateform) => {
                        const t = (plateform?.type || '').toLowerCase();
                        return t === 'glovo' || t === 'glovo_sisters';
                      })
                    : false;
                setHasGlovoPlateform(hasGlovo);
            } catch (error) {
                console.error('Unable to fetch plateforms for sidebar', error);
                setHasGlovoPlateform(false);
            }
        };

        if (role?.includes('admin') || role?.includes('manager')) {
            detectGlovoPlateforms();
        }
    }, [role]);

    useEffect(() => {
        // Listen for sidebar toggle button clicks
        const handleToggle = (e) => {
            if (e.target.closest('.sidebar-toggle, .js-sidebar-toggle')) {
                setSidebarOpen(prev => !prev);
            }
        };

        const handleForceCollapse = () => {
            setSidebarOpen(false);
        };
        const handleShellToggle = () => setSidebarOpen(prev => !prev);

        document.addEventListener('click', handleToggle);
        window.addEventListener('pegasus:collapse-sidebar', handleForceCollapse);
        window.addEventListener('pegasus:toggle-sidebar', handleShellToggle);
        
        return () => {
            document.removeEventListener('click', handleToggle);
            window.removeEventListener('pegasus:collapse-sidebar', handleForceCollapse);
            window.removeEventListener('pegasus:toggle-sidebar', handleShellToggle);
        };
    }, []);

    const fetchStores = async () => {
        const response = await axios.get(`${API_URL}/distinctStoreIds`, header());
        setStores(response.data.response.filter(x => x.store_type == "glovo" || x.store_type == "site").map(store => ({
            value: store.storeCode,
            label: store.name
        })));
    };
    const [openMenus, setOpenMenus] = useState({});
    const handleStoreIdsChange = (selected) => {
        window.open('/storeExpress/' + selected.value, '_blank');
    };
    const handleLinkClick = () => {
        if (isMobile) {
            setSidebarOpen(false);
        }
    };

    const getMuiIcon = (label) => {
        if (!label) return <DashboardIcon />;
        const key = String(label).toLowerCase();
        if (key.includes('dash') || key.includes('dashboard')) return <DashboardIcon />;
        if (key.includes('glovo') || key.includes('delivery') || key.includes('moto') || key.includes('vehic')) return <DirectionsCarIcon />;
        if (key.includes('stock') || key.includes('warehouse') || key.includes('storehouse')) return <WarehouseIcon />;
        if (key.includes('inventory') || key.includes('inventaire')) return <Inventory2Icon />;
        if (key.includes('calc') || key.includes('calculator')) return <CalculateIcon />;
        if (key.includes('compta') || key.includes('cmi') || key.includes('account')) return <AccountBalanceWalletIcon />;
        if (key.includes('product') || key.includes('produit') || key.includes('catalog')) return <CategoryIcon />;
        if (key.includes('carrefour') || key.includes('orders')) return <ShoppingCartIcon />;
        if (key.includes('plateform') || key.includes('platform')) return <StorefrontIcon />;
        if (key.includes('users') || key.includes('utilisateurs')) return <PeopleIcon />;
        if (key.includes('image') || key.includes('processing') || key.includes('photo')) return <PhotoLibraryIcon />;
        if (key.includes('deliver') || key.includes('deliveries')) return <LocalShippingIcon />;
        if (key.includes('marketing') || key.includes('slides')) return <LocalOfferIcon />;
        if (key.includes('tasks') || key.includes('tâches')) return <FormatListBulletedIcon />;
        if (key.includes('settings') || key.includes('param')) return <SettingsIcon />;
        return <TuneIcon />;
    };
    const sidebarItems = [
        {
            label: "Dashboard",
            path: "/",
            icon: <i className="align-middle" data-feather="sliders"></i>,
            roles: ["admin",'manager']
        },
        {
            label: "Mail",
            path: "/mail",
            icon: <MailIcon />,
            roles: ["admin","manager"]
        },
        {
            label: "Messagerie",
            path: "/messaging",
            icon: <i className="fa-solid fa-comments"></i>,
            roles: ["admin","support"]
        },
        {
            label: "Track Vehicules",
            path: "/tracker",
            icon: <i className="fa-solid fa-map-location-dot"></i>,
            roles: ["admin"]
        },
        {
            label: "Inventory",
            path: "/inventory",
            icon: <i className="fa-solid fa-boxes-stacked"></i>,
            roles: ["admin","manager"]
        },
        {
            label: "Ouvrir",
            path: "/inventory",
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "/inventory"
        },
        {
            label: "Inventaire Calcul",
            path: "/inventory-calc",
            icon: <i className="fa-solid fa-calculator"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "/inventory",
            requiresInventoryAsk: true
        },
        {
            label: "Stock to Fill",
            path: "/inventory/stock-to-fill",
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "/inventory",
        },
        {
            label: "Comptabilité",
            path: "#accounting",
            icon: <i className="fa-solid fa-scale-balanced"></i>,
            roles: ["admin","manager"]
        },
        {
            label: "Cmi",
            path: "/cmiExcel",
            icon: <i className="fa-solid fa-file-excel"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#accounting"
        },
        {
            label: "Carrefour Commande",
            path: "/ordersForCarrefour",
            icon: <i className="fa-solid fa-cart-shopping"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#accounting"
        },
        {
            label: "Produits",
            path: "#storeQuickProduct",
            icon: <i className="fa-solid fa-display"></i>,
            roles: ["admin","manager","accountant","operator","driver","user","carrefour"]
        },
         {
            label: "Ouvrir",
            path: "/storeQuickProduct",
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Statistiques ventes",
            path: "/product-sales-statistics",
            icon: <i className="fa-solid fa-chart-line"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Composants",
            path: "/components",
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Addons Produit",
            path: "/product-addons",
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Créer Commande Interne",
            path: "/internal-order-create",
            icon: <i className="fa-solid fa-plus-circle"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Image Processing",
            path: "/image-processing",
            icon: <i className="fa-regular fa-image"></i>,
            roles: ["admin","manager","accountant","operator","driver","user","carrefour"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Collections Spéciales",
            path: "/special-collections",
            icon: <i className="fa-solid fa-layer-group"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#storeQuickProduct"
        },
        {
            label: "Catégories",
            path: "/product-categories",
            isChild: true,
            parentPath: "#storeQuickProduct",
            icon: <i className="fa-solid fa-tags"></i>,
            roles: ["admin"]
        },
        {
            label: "Carrefour",
            path: "#carrefourSell",
            icon: <ShoppingCartIcon />,
            roles: ["admin","manager","accountant","carrefour"]
        },
         {
            label: "Ouvrir",
            path: "/carrefourSell",

            roles: ["admin","manager","accountant","carrefour"],
            isChild: true,
            parentPath: "#carrefourSell"
        },
        {
            label: "Catalogue",
            path: "/catalog",
            icon: <i className="fa-solid fa-box-open"></i>,
            roles: ["admin","manager","accountant"],
            isChild: true,
            parentPath: "#carrefourSell"
        },
        {
            label: "CarrefourOrderToday",
            path: "/carrefour/orders/today",
            icon: <i className="fa-solid fa-calendar-day"></i>,
            roles: ["admin","manager","carrefour"],
            isChild: true,
            parentPath: "#carrefourSell"
        },
        {
            label: "Commandes",
            path: "#orders",
            icon: <ShoppingCartIcon />,
            roles: ["admin","manager","accountant","operator","user","carrefour"]
        },
        {
            label: "Commandes par canal",
            path: "/orders-summary",
            icon: <i className="fa-solid fa-table-list"></i>,
            roles: ["admin"],
            isChild: true,
            parentPath: "#orders"
        },
        {
            label: "Order Handle",
            path: "/screens/login",
            icon: <ShoppingCartIcon />,
            roles: ["admin","manager","accountant","operator","user","carrefour"],
            isChild: true,
            parentPath: "#orders"
        },
        {
            label: "Devis",
            path: "/quotes",
            icon: <i className="fa-solid fa-file-signature"></i>,
            roles: ["admin","manager","accountant","operator","user","carrefour"],
            isChild: true,
            parentPath: "#orders"
        },
        {
            label: "POS",
            path: "/pos",
            icon: <i className="fa-solid fa-cash-register"></i>,
            roles: ["admin","manager","operator","driver"]
        },
        {
            label: "Ouvrir",
            path: "/pos",
            icon: <i className="fa-solid fa-up-right-from-square"></i>,
            roles: ["admin","manager","operator","driver"],
            isChild: true,
            parentPath: "/pos"
        },
        {
            label: "Sessions caisse",
            path: "/pos/cash-sessions",
            icon: <i className="fa-solid fa-cash-register"></i>,
            roles: ["admin","manager","operator","driver"],
            isChild: true,
            parentPath: "/pos"
        },
        {
            label: "Méthodes de paiement",
            path: "/payment-methods",
            icon: <i className="fa-solid fa-credit-card"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "/pos"
        },
        {
            label: "Remises",
            path: "/pos/discounts",
            icon: <i className="fa-solid fa-percent"></i>,
            roles: ["admin","manager","operator","driver"],
            isChild: true,
            parentPath: "/pos"
        },
        {
            label: "Retours",
            path: "/pos/returns",
            icon: <i className="fa-solid fa-rotate-left"></i>,
            roles: ["admin","manager","operator","driver"],
            isChild: true,
            parentPath: "/pos"
        },
        {
            label: "Woocommerce",
            path: "#woocommerce",
            icon: <PublicIcon />,
            roles: ["admin","manager","accountant","operator","driver"]
        },
        {
            label: "Commandes Woocommerce",
            path: "/woo-orders",
            icon: <i className="fa-solid fa-receipt"></i>,
            roles: ["admin","manager","accountant","operator","driver"],
            isChild: true,
            parentPath: "#woocommerce"
        },
        {
            label: "Ajouter un produit",
            path: "/addproductsite",
            icon: <i className="fa-solid fa-globe"></i>,
            roles: ["admin","manager","accountant"],
            isChild: true,
            parentPath: "#woocommerce"
        },
        {
            label: "Catégories",
            path: "/woo-categories",
            icon: <i className="fa-solid fa-tags"></i>,
            roles: ["admin","manager"],
            isChild: true,
            parentPath: "#woocommerce"
        },
        {
            label: "Livraison",
            path: "/woo-delivery-settings",
            icon: <i className="fa-solid fa-calendar-days"></i>,
            roles: ["admin"],
            isChild: true,
            parentPath: "#woocommerce"
        },
        {
            label: "Voir les produits",
            path: "/productList",
            icon: <i className="align-middle" data-feather="check-square"></i>,
            roles: ["admin", "manager"],
            isChild: true,
            parentPath: "#woocommerce"
        },
        {
            label: "Cmd. Glovo",
            path: "/ordersGlovo",
            icon: <i className="fa-solid fa-motorcycle"></i>,
            roles: ["admin","manager","accountant","operator","driver","carrefour"]
        },
        {
            label: "Coursier",
            path: "#coursier",
            icon: <DirectionsCarIcon />,
            roles: ["driver", "admin"]
        },
        {
            label: "Commandes",
            path: "/driver/orders",
            icon: <i className="fa-solid fa-list"></i>,
            roles: ["driver", "admin"],
            isChild: true,
            parentPath: "#coursier"
        },
        {
            label: "Kooul",
            path: "/kooul/sync",
            icon: <i className="fa-solid fa-cloud" />,
            roles: ["admin","manager"]
        },
        {
            label: "Ouvrir",
            path: "/ordersGlovo",
            isChild: true,
            parentPath: "/ordersGlovo",
            roles: ["admin","manager","operator","driver","carrefour"]
        },
        {
            label: "Imprimer Mot",
            path: "/glovo-message",
            isChild: true,
            parentPath: "/ordersGlovo",
            roles: ["admin","manager","accountant","operator","driver","user","carrefour"]
        },
        {
            label: "Plateformes",
            path: "#glovo-plateforms",
            icon: <i className="fa-solid fa-plug-circle-bolt"></i>,
            roles: ["admin", "manager"],
            requiresGlovoPlateform: true
        },
        {
            label: "Glovo",
            path: "/plateforms/glovo",
            isChild: true,
            parentPath: "#glovo-plateforms",
            icon: <i className="fa-solid fa-person-biking"></i>,
            roles: ["admin", "manager"],
            requiresGlovoPlateform: true
        },
        {
            label: "Tracking",
            path: "/glovo/tracking",
            isChild: true,
            parentPath: "#glovo-plateforms",
            icon: <i className="fa-solid fa-chart-line"></i>,
            roles: ["admin", "manager"],
            requiresGlovoPlateform: true
        },
        {
            label: "Marjane Mall",
            path: "/plateforms/marjanemall",
            isChild: true,
            parentPath: "#glovo-plateforms",
            icon: <i className="fa-solid fa-bag-shopping"></i>,
            roles: ["admin", "manager"]
        },
        {
            label: "Glovo Sisters",
            path: "/plateforms/glovo-sisters",
            isChild: true,
            parentPath: "#glovo-plateforms",
            icon: <i className="fa-solid fa-person-biking"></i>,
            roles: ["admin", "manager"]
        },
        {
            label: "Paramètres",
            path: "#settings",
            icon: <SettingsIcon />,
            roles: ["admin", "manager"]
        },
        {
            label: "Stores",
            path: "/stores",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-shop"></i>,
            roles: ["admin"]
        },
        {
            label: "Sociétés",
            path: "/companies",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-building"></i>,
            roles: ["admin"]
        },
        {
            label: "Plateformes",
            path: "/plateforms",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-plug"></i>,
            roles: ["admin"]
        },
        {
            label: "Utilisateurs",
            path: "/users",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-user"></i>,
            roles: ["admin"]
        },
        {
            label: "Remote Printers",
            path: "/remote-printers",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-print"></i>,
            roles: ["admin", "manager", "user"]
        },
        {
            label: "Tokens",
            path: "/tokens",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-key"></i>,
            roles: ["admin"]
        },
        {
            label: "Screen Views",
            path: "/screen-views",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-display"></i>,
            roles: ["admin"]
        },
        {
            label: "Variables",
            path: "/variables",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-list"></i>,
            roles: ["admin", "manager"]
        },
        {
            label: "Code à Bar",
            path: "/barcode",
            isChild: true,
            parentPath: "#settings",
            icon: <i className="fa-solid fa-barcode"></i>,
            roles:["admin","manager","accountant"]
        },
        {
            label: "Pointage",
            path: "/pointage",
            icon: <i className="fa-regular fa-clock"></i>,
            roles: ["admin","manager","user","carrefour","accountant"]
        },
        {
            label: "Store express",
            path: "#",
            icon: <i className="align-middle" data-feather="book"></i>,
            roles: ["admin","manager","accountant"],
            isModalTrigger: true
        },
        {
            label: "Marketing",
            path: "#marketing",
            icon:<i className="fa-brands fa-facebook"></i>,
            roles: ["admin","manager"]
        },
        {
            label: "Slides Stores",
            path: "/slides",
            isChild: true,
            parentPath: "#marketing",
            roles: ["admin","manager","accountant"]
        },
        {
            label: "Inventaire Calcul",
            path: "/inventory-calc",
            icon: <i className="fa-solid fa-calculator"></i>,
            roles: ["carrefour","operator","driver"],
            requiresInventoryAsk: true
        },
        {
            label: "Management",
            path: "#management",
            icon: <FormatListBulletedIcon />,
            allAuthenticated: true
        },
        {
            label: "Tâches",
            path: "/tasks",
            isChild: true,
            parentPath: "#management",
            icon: <i className="fa-solid fa-list-check"></i>,
            allAuthenticated: true
        },
        {
            label: "Commandes internes",
            path: "/internal-orders",
            icon: <i className="fa-solid fa-diagram-project"></i>,
            roles: ["admin","manager","accountant","operator","driver","user","carrefour","support"]
        }
    ];

    const isAdminManager = role?.includes('admin') || role?.includes('manager');
    const isDriver = role?.includes('driver');
    const isCoursierOnly = isDriver && !isAdminManager;
    const userHasRole = (roles = []) => roles.some(r => role?.includes(r));
    const canSeeItem = (item) => {
        if (item.allAuthenticated) return true;
        // If the current user is a driver, restrict visibility to only the Coursier section
        if (isCoursierOnly) {
            return item.path === '#coursier' || item.parentPath === '#coursier' || item.path === '/driver/orders';
        }

        if (!userHasRole(item.roles)) {
            return false;
        }

        if (
            (item.path === '#coursier' || item.parentPath === '#coursier' || item.path === '/driver/orders') &&
            role?.includes('manager') &&
            !role?.includes('admin')
        ) {
            return false;
        }

        if (item.requiresInventoryAsk && !hasInventoryAsk && !isAdminManager) {
            return false;
        }

        if (item.requiresGlovoPlateform && !hasGlovoPlateform) {
            return false;
        }

        return true;
    };


    const isActive = path => path && !path.startsWith('#') && (
        location.pathname === path || (path !== '/' && location.pathname.startsWith(path + '/'))
    );
    const visibleParents = sidebarItems.filter(item => !item.isChild && canSeeItem(item));
    const expanded = sidebarOpen || isMobile;
    const renderLink = (item) => {
        const content = <>
            <span className="pegasus-nav-icon" aria-hidden="true">{item.icon || getMuiIcon(item.label)}</span>
            {expanded && <span className="pegasus-nav-label">{item.label}</span>}
        </>;
        if (item.isModalTrigger) return <button type="button" className="pegasus-nav-item" title={!expanded ? item.label : undefined}
            onClick={() => { fetchStores(); handleLinkClick(); }} data-bs-toggle="modal" data-bs-target="#storesSideBar">{content}</button>;
        return <Link to={item.path} className="pegasus-nav-item" title={!expanded ? item.label : undefined}
            aria-label={item.label} aria-current={isActive(item.path) ? 'page' : undefined}
            data-active={isActive(item.path)} onClick={handleLinkClick}>{content}</Link>;
    };
    const menu = <div className="pegasus-sidebar-inner">
        <Link to="/" className="pegasus-brand" aria-label="Le Céladon, accueil" onClick={handleLinkClick}>
            <BrandLogo className="pegasus-brand-mark" alt="" />
            {expanded && <span><strong>le céladon</strong><small>Pegasus workspace</small></span>}
        </Link>
        <nav className="pegasus-nav" aria-label="Menu principal">
            {expanded && <div className="pegasus-nav-caption">Votre espace de travail</div>}
            {visibleParents.map(item => {
                const children = sidebarItems.filter(child => child.isChild && child.parentPath === item.path && canSeeItem(child));
                if (!children.length) return <React.Fragment key={item.path}>{renderLink(item)}</React.Fragment>;
                const menuOpen = openMenus[item.path] ?? children.some(child => isActive(child.path));
                return <Collapsible.Root key={item.path} open={expanded && menuOpen}
                    onOpenChange={open => { if (!isMobile) setSidebarOpen(true); setOpenMenus(prev => ({ ...prev, [item.path]: open })); }}>
                    <Collapsible.Trigger className="pegasus-nav-item" title={!expanded ? item.label : undefined}
                        aria-label={item.label} data-active={children.some(child => isActive(child.path))}>
                        <span className="pegasus-nav-icon" aria-hidden="true">{item.icon || getMuiIcon(item.label)}</span>
                        {expanded && <><span className="pegasus-nav-label">{item.label}</span><ChevronRight className="pegasus-nav-chevron" size={13} /></>}
                    </Collapsible.Trigger>
                    <Collapsible.Content className="pegasus-nav-children">
                        {children.map(child => <React.Fragment key={child.path}>{renderLink(child)}</React.Fragment>)}
                    </Collapsible.Content>
                </Collapsible.Root>;
            })}
        </nav>
        <div className="pegasus-sidebar-bottom"><span className="pegasus-status-dot" />{expanded && <span>Le Céladon · Pegasus</span>}</div>
    </div>;

    return <>
        {isMobile ? <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
            <SheetContent onCloseAutoFocus={event => {
                event.preventDefault();
                document.getElementById('pegasus-menu-toggle')?.focus();
            }}>
                <SheetTitle className="sc-sr-only">Navigation Le Céladon</SheetTitle>
                <SheetDescription className="sc-sr-only">Navigation vers les pages autorisées de votre compte.</SheetDescription>
                {menu}
            </SheetContent>
        </Sheet> : <aside className="pegasus-ui pegasus-sidebar" data-collapsed={!sidebarOpen}>{menu}</aside>}
        <Modal modalId="storesSideBar" title="Choix du Store">
            <div className="col-12">
                <label className="form-label">Store IDs</label>
                <Select options={stores} value={selectedStore} onChange={handleStoreIdsChange}
                    className="basic-multi-select" classNamePrefix="select" />
            </div>
        </Modal>
    </>;
}

export default Sidebar;
